import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
 
import { useNavigate } from 'react-router-dom';
import { usePortfolio } from '../contexts/PortfolioContext';
import PortfolioSection from '../components/portfolio/PortfolioSection';

const Settings = () => {
 
  const [loading, setLoading] = useState(true);
 
  const auth = getAuth();
  const navigate = useNavigate();
  const { selectedPortfolio } = usePortfolio();
  
  useEffect(() => {
    const loadSettings = async () => {
      if (!auth.currentUser?.email) {
        navigate('/login');
        return;
      }

      try {
        if (!selectedPortfolio) {
          console.warn('No portfolio selected');
          setLoading(false);
          return;
        }
 
        
  
      } catch (error) {
        console.error('Ayarlar yüklenirken hata:', error);
   
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, [auth.currentUser, navigate, selectedPortfolio]);

 
  if (!auth.currentUser?.email) {
    navigate('/login');
    return null;
  }

  if (!selectedPortfolio) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center text-gray-600 dark:text-gray-400">
          Lütfen bir portföy seçin
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

 

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Portföy Yapılandırması */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Portföy Yapılandırması</h2>
        <PortfolioSection 
          userId={auth.currentUser?.email} 
          selectedPortfolioId={selectedPortfolio?.id}
        />
      </div>

 
    </div>
  );
};

export default Settings;